import type { LocaleResources } from '../types';

/**
 * Menu bar/toolbar related UI string resources
 * Used in main-toolbar, main-tab, etc.
 */
export const menuBarStr: LocaleResources['menuBarStr'] = {
  error: {
    /** Seed contribution amount is 0 */
    seedAmountZero: 'Please set seed contribution amount.',
    cannotContributeMoreThanReserved: 'Cannot contribute more than the reserved amount.',
    cannotWithdrawMoreThanAvailable: 'Cannot withdraw more than {type} amount.',
    notRunning: 'Investment is not running.',
    noWithdrawableProfit: 'Withdrawable profit is 0.',
    withdrawAmountInvalid: 'Withdrawal amount must be greater than 0.',
    cannotWithdrawMoreThanProfit: 'Cannot withdraw more than available profit.',
    selectExchange: 'Please select an exchange.',
    endTimeMustBeAfterStart: ' End time must be after start time.',
    virtualBalanceMin: 'Virtual balance must be at least {min}.',
  },
  toolbar: {
    selectSymbol: 'Select Symbol',
    strategy: 'Select Strategy',
    timeframeSetting: '{name} Settings',
    exchange: 'Exchange',
    marginMode: 'Margin Mode',
    leverage: 'Leverage',
    balance: 'Balance',
    loadBalance: 'Load Balance',
    reserved: 'Reserved Amount',
    seed: 'Seed Contribution',
    seedWithdraw: 'Seed Withdrawal',
    profitWithdraw: 'Profit Withdrawal',
    evalSeed: 'Evaluation',
    contribution: 'Contribution',
    evalProfit: 'Unrealized P&L',
    profitRate: 'P&L Rate',
    goalAchieve: 'Goal Achieved',
    investable: 'Available (Balance - Reserved)',
    profitTarget: 'Profit Target',
    stopLoss: 'Stop Loss',
    investMode: 'Invest Mode',
    startTime: 'Start Time',
    endTime: 'End Time',
    investablePercent: '{percent}% of Available ({amount})',
    percentAmount: '{percent}% - {amount}',
  },
  label: {
    wallet: 'Wallet',
    holding: 'Holdings',
    reserved: 'Reserved',
    contribution: 'Contribution',
    evaluation: 'Evaluation',
    seed: 'Seed',
    withdraw: 'Withdraw',
    contribute: 'Contribute',
    profit: 'Profit',
    profitRate: 'Rate',
    goal: 'Goal',
    achievement: 'Achieved',
    investable: 'Available',
    strategySave: 'Save',
    amountInput: 'Enter amount',
  },
  button: {
    startBot: 'Start Bot',
    stopBot: 'Stop Bot',
    start: 'Start',
    stop: 'Stop',
    saveAndChange: 'Save and Change',
    saveAsAndChange: 'Save As and Change',
    changeWithoutSave: 'Change without Saving',
    noChange: 'No Change',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  dropdown: {
    reservedOf: '{amount} of Reserved',
    investableOf: '{amount} of Available',
    withdrawableProfitOf: '{amount} of Withdrawable Profit',
  },
  menu: {
    save: 'Save',
    saveAs: 'Save As',
  },
  message: {
    dataGenComplete: 'Required indicators and data generation for checked symbols is complete.',
    backtestComplete: 'Backtest completed.',
    cannotChangeTimeframe: 'Cannot change timeframe settings while investing. Please stop and try again.',
    noWithdrawableProfit: 'No withdrawable profit',
    currentStrategy: 'Currently selected strategy',
    changeStrategy: 'Change Strategy',
    backtestStartTimeRequired: 'Please select a backtest start time.',
    withdrawComplete: '{amount} withdrawn successfully',
    stopFailed: 'Stop failed',
    confirmStopWithExit: 'All positions will be closed before stopping. Do you want to continue?',
    positionExitFailed:
      'Failed to close positions for the following symbols. Please close them manually on the exchange.\n{symbols}',
    unsavedChanges: 'Strategy {strategy} has unsaved changes. What would you like to do?',
  },
  loading: {
    marketChanging: 'Changing markets. Please wait...',
    stopping: 'Stopping. Please wait...',
    generatingSignals: '{backtest}Generating trade signals and history for symbols...',
    autoExiting: 'Automatically closing positions. Please wait...',
    backtest: 'Backtest ',
  },
  modal: {
    autoSplitEntry: 'Auto Split Entry',
  },
  mainTab: {
    confirmTabChange: 'Investment will be stopped to change tabs. Do you want to continue?',
    confirmTabChangeWithExit:
      'All positions will be closed and investment will be stopped to change tabs. Do you want to continue?',
    seedEvalZero: 'Seed evaluation is 0. Please add seed using the [Seed Contribution] function.',
    darkModeToggle: 'Toggle Dark Mode',
    refresh: 'Refresh',
    settings: 'Settings',
  },
  timeframesEditor: {
    title: '{title} Settings',
    strategyUpdated: 'Strategy {name} has been updated.',
  },
  marketTicker: {
    viewChart: 'View {symbol} Chart',
    highLow: 'H/L',
    change: 'Change',
    volume: 'Volume',
  },
};
